export default __webpack_public_path__ + "static/media/charniere.2fb5b591.svg";